<template>
  <!-- <div class="container"> -->
  <div class="">
    <div class="title">
      <gl-sub-text>初購入</gl-sub-text>
    </div>
    <div class="option-inline">
      <label class="option-label">過去</label>
      <md-field class="option-field">
        <md-input
          v-model.number="_trialDays"
          type="number"
          class="option-input"
          min="1"
          required
        ></md-input>
      </md-field>
      <label class="option-label">日間購入履歴なし</label>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  props: {
    trialDays: {
      type: Number,
    },
  },
  computed: {
    _trialDays: {
      get() {
        return this.trialDays
      },
      set(newVal) {
        if (newVal === '') {
          this.$emit('update:trialDays', undefined)
        } else {
          this.$emit('update:trialDays', newVal)
        }
      },
    },
    errors() {
      const errors = []
      const trialDays = this.trialDays
      const isInvalid =
        trialDays == null ||
        trialDays === '' ||
        typeof trialDays !== 'number' ||
        Number.isNaN(trialDays)
      if (isInvalid) {
        // null or undefined
        errors.push('初購入を選択してください')
      } else if (trialDays < 1) {
        errors.push('過去の日数は1以上を入力してください')
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.option-inline {
  display: flex;
}
.option-input {
  width: 60px;
}
.option-field {
  width: 60px;
}
.option-label {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 16px;
  margin-right: 16px;
}
</style>
